export default __webpack_public_path__ + "fonts/fontello.a4a32bdda4677c1f2c19b8a3e6efce4b.ttf";